import {
  axiosSysApi
} from '@/axios_init'

import {
  getData,
  saveData
} from '@/api/local_storage'

import {
  PSZX_LIST
} from '@/api/static_data'

import {
  getInvoicingTodayData
} from '@/api/oli_api'

// 石油相关
const state = {
  oilArea: null,
  inputDataLoading: true,
  todayStr: '',
  yesterDayStr: '',
  canChoosePSZXs: [],
  // 流程状态 0: start 10:数据导入完成 20:数据校验完成 30:预测完成 40: 订单分配完成 -90: 流程错误
  flowStatus: 0,
  gasLocation: [],
  depotLocation: []
}

const getters = {
  oilArea: state => state.oilArea,
  todayStr: state => state.todayStr,
  yesterDayStr: state => state.yesterDayStr,
  flowStatus: state => state.flowStatus,
  canChoosePSZXs: state => state.canChoosePSZXs,
  gasLocation: state => state.gasLocation,
  depotLocation: state => state.depotLocation,
  inputDataLoading: state => state.inputDataLoading
}

const actions = {
  setCanChoosePSZXs ({ commit, dispatch, getters }, data) {
    let newDatas = []
    PSZX_LIST.forEach((item) => {
      if (data.includes(item['key'])) {
        newDatas.push(item)
      }
    })
    commit('setCanChoosePSZXs', newDatas)
    dispatch('setOilArea', getData('oil_area'))
  },
  setOilArea ({ commit, getters }, data) {
    let canChoose = false
    if (data) {
      getters.canChoosePSZXs.forEach((item) => {
        if (item['key'] === data) {
          canChoose = true
        }
      })
    }
    if (!canChoose) {
      data = getters.canChoosePSZXs.length > 0 ? getters.canChoosePSZXs[0].key : null
    }
    saveData({key: 'oil_area', data})
    if (getters.oilArea && getters.oilArea !== data) {
      window.location.reload()
    }
    commit('setOilArea', data)
  },
  loadLocationData ({ commit, getters, dispatch }, data) {
    // 加油站、油库位置数据
    axiosSysApi.get('/static/location.json').then(function (response) {
      dispatch('setGasLocation', response.data['加油站位置'])
      dispatch('setDepotLocation', response.data['油库位置'])
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '分析预测异常',
        message: '错误信息:' + e
      })
      console.log(e)
    })
  },
  setInputDataLoading ({ commit }, data) {
    commit('setInputDataLoading', data)
  },
  setTodayStr ({ commit }, data) {
    commit('setTodayStr', data)
  },
  setGasLocation ({ commit }, data) {
    commit('setGasLocation', data)
  },
  setDepotLocation ({ commit, dispatch }, data) {
    let newData = []
    for (let key in data) {
      newData.push({
        name: key,
        value: data[key]
      })
    }
    dispatch('setAllMapStation', newData)
    commit('setDepotLocation', data)
  },
  setYesterDayStr ({ commit }, data) {
    commit('setYesterDayStr', data)
  },
  setFlowStatus ({ commit }, data) {
    commit('setFlowStatus', data)
  },
  loadInputData ({ dispatch, getters }) {
    dispatch('setInputDataLoading', true)
    getInvoicingTodayData().then((data) => {
      dispatch('setTodayStr', data.toDay2)
      dispatch('setYesterDayStr', data.yesterDay)
      if (data.data.length) {
        dispatch('dealDatasToHisJxcDatas', data.data)
        dispatch('setInputJxcOk')
      }
      if (data.data_depot_volume === '1') {
        dispatch('setInputDepotValumeOk')
      }
      if (data.data_plant === '1') {
        dispatch('setInputOrderPlantOk')
      }
      if (data.to_goods === '1') {
        dispatch('setInputToGoodsOk')
      }
      dispatch('setInputDataLoading', false)
    }).catch((e) => {
      dispatch('showNoticeMsg', {
        type: 'warning',
        title: '系统提示',
        message: '服务器错误，请联系管理员'
      })
      dispatch('setInputDataLoading', false)
    })
  }
}

const mutations = {
  setCanChoosePSZXs (state, data) {
    state.canChoosePSZXs = data
  },
  setOilArea (state, data) {
    state.oilArea = data
  },
  setInputDataLoading (state, data) {
    state.inputDataLoading = data
  },
  setGasLocation (state, data) {
    state.gasLocation = data
  },
  setDepotLocation (state, data) {
    state.depotLocation = data
  },
  setFlowStatus (state, data) {
    state.flowStatus = data
  },
  setTodayStr (state, data) {
    state.todayStr = data
  },
  setYesterDayStr (state, data) {
    state.yesterDayStr = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/base.js